export const isInternetExplorer = () =>
  navigator &&
  navigator.userAgent &&
  isInternetExplorerUserAgent(navigator.userAgent);

export const isSafari = () =>
  navigator && navigator.userAgent && isSafariUserAgent(navigator.userAgent);

export const isSafariUserAgent = (userAgentString) =>
  userAgentString.indexOf("Safari") > -1 &&
  userAgentString.indexOf("Chrome") < 0;

export const isInternetExplorerUserAgent = (userAgentString) =>
  userAgentString.indexOf("MSIE") > -1 ||
  userAgentString.indexOf("Trident/") > -1;
